<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item v-if="this.user.user.roles[0].id == 1" :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>利润报表</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <div class="searchleft">
                        <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                            <el-form-item label="客户类型">
                                <el-select v-model="searchform.type" placeholder="请选择" style="width:150px">
                                    <el-option :label="$t('buxian')" :value="null"></el-option>
                                    <el-option label="新客" value="1"></el-option>
                                    <el-option label="老客" value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item :label="$t('channel')">
                                <el-select size="small" v-model="searchform.blurry" multiple :placeholder="$t('qxz')" style="width:150px">
                                    <el-option v-for="item in typeList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.name">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="App">
                                <el-select size="small" v-model="searchform.app" multiple @change="onAppChange" :placeholder="$t('qxz')" style="width:150px">
                                    <el-option :label="$t('buxian')" :value="null"></el-option>
                                    <el-option v-for="item in appChannelList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.name">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="子产品">
                                <el-select size="small" v-model="searchform.platform" :disabled="subProductChannelList.length === 0" :placeholder="$t('qxz')" style="width:150px">
                                    <el-option :label="$t('buxian')" :value="null"></el-option>
                                    <el-option
                                        v-for="item in subProductChannelList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.name">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="到期日时间">
                                <el-date-picker
                                    v-model="value1"
                                    type="daterange"
                                    size="small"
                                    @change="checkdata"
                                    range-separator="至"
                                    value-format="yyyy-MM-dd"
                                    start-placeholder="开始时间"
                                    end-placeholder="结束时间">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item>
                                <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="top"></div>
                    <el-table :data="list" :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column prop="maturity_date" label="到期日(day)"></el-table-column>
                        <el-table-column prop="transaction_count" label="笔数"></el-table-column>
                        <el-table-column prop="notional_loan_amount" label="名义借款金额(人民币)"></el-table-column>
                        <el-table-column prop="disbursed_amount" label="放款到账金额(人民币)"></el-table-column>
                        <el-table-column prop="composite_rate" label="综合费率"></el-table-column>
                        <el-table-column prop="production_ratio" label="投产比率"></el-table-column>
                        <el-table-column prop="total_repayment_Amount" label="总回款金额(人民币)"></el-table-column>
                        <el-table-column prop="gross_profit" label="毛利(人民币)"></el-table-column>
                        <el-table-column prop="extension_fee" label="展期费用(人民币)"></el-table-column>
                        <el-table-column prop="installment_fee" label="分期费用(人民币)"></el-table-column>
                        <el-table-column prop="actual_overdue_default_collections" label="实收逾期和违约(人民币)"></el-table-column>
                        <el-table-column prop="waived_amount" label="减免金额(人民币)"></el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                form: {
                    id: null,
                    phone: null,
                    userName: null,
                    email: null,
                    channel: null,
                },
                searchform: {
                    blurry: null,
                    app:null,
                    platform:null,
                },
                loading: false,
                showadd: false,
                phone:null,
                list: [],
                value1:null,
                typeList: [],
                appChannelList: [],
                subProductChannelList: [],
            }
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            this.value1 = this.getNowTime()
            this.getTypeList()
            this.getList()
            this.getAppChannel()

        },
        methods: {
            onAppChange(val) {
                this.searchform.platform=null
                if (val === null) {
                    this.subProductChannelList=[]
                } else {
                    this.getSubProductChannel();
                }
            },
            getAppChannel() {
                _api.get(apiurl.appChannel, {
                }).then(res => {
                    this.appChannelList = res.data
                })
            },
            getSubProductChannel() {
                _api.get(apiurl.subProductChannel, {
                    app: this.searchform.app
                }).then(res => {
                    this.subProductChannelList = res.data
                })
            },
            getNowTime() {
                const now = Date.now();
                const startDate = new Date(now - 7 * 86400000); // 7天前
                const endDate = new Date(now + 1 * 86400000);   // 1天后

                // 本地时间格式化函数
                const formatLocalDate = (date) => {
                    return [
                    date.getFullYear(),
                    String(date.getMonth() + 1).padStart(2, '0'),
                    String(date.getDate()).padStart(2, '0')
                    ].join('-');
                };

                return [formatLocalDate(startDate), formatLocalDate(endDate)];
            },
            getTypeList() {
                _api.get(apiurl.typeList, {
                }).then(res => {
                    this.typeList = res.data
                })
            },
            getList() {
                this.loading = true
                if (this.value1 == null) {
                    this.$message.error(this.$t('tel87'))
                    return
                }
                const type = null; 
                if (this.searchform.blurry != null) {
                    this.type = this.searchform.blurry.join(",")
                }

                const type1 = null; 
                if (this.searchform.app != null) {
                    this.type1 = this.searchform.app.join(",")
                }

                _api.get(apiurl.profit, {
                    type: this.type,
                    createTime: this.value1,
                    customerType: this.searchform.type,
                    app: this.type1,
                    platform: this.searchform.platform,
                }).then(res => {
                    this.loading = false
                    this.list = res.data
                })
            },
            onSubmit() {
                this.getList()
            },
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .top {
        margin-top: 15px;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>